import React, { useState, useEffect } from "react";
import styles from "./Navigation.module.css";
import { Facebook, Instagram } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleToggle = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleAnchorClick = (e) => {
      const target = e.target.closest('a[href^="/#"]');
      if (target && isMenuOpen) {
        closeMenu();
      }
    };

    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, [isMenuOpen]);

  const location = useLocation();
  useEffect(() => {
    // Jeśli w URL jest hash (np. /#gallery, /#contact)
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth"
        });
      }
    } else {
      // Jeśli nie ma hasha (np. po prostu /), przewiń na samą górę
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [location]); // uruchamia się za każdym razem, gdy zmienia się URL

  return (
    <nav className={styles.navbar}>
      <div className={styles.logo}>
        <a href="/#hero">ArtKoz</a>
      </div>
      <ul className={`${styles.navLinks} ${isMenuOpen ? styles.active : ""}`}>
        <li>
          <a href="/#hero">Strona główna</a>
        </li>
        <li>
          <a href="/#aboutUs">O nas</a>
        </li>
        <li>
          <a href="/#portfolio">Portfolio</a>
        </li>
        <li>
          <a href="/#service">Usługi</a>
        </li>
        <li>
          <a href="/#work">Jak pracujemy</a>
        </li>
        <li>
          <Link to="/web" onClick={closeMenu} className={styles.navLink}>
            Strony WWW
          </Link>
        </li>
        <li>
          <Link to="/training" onClick={closeMenu} className={styles.navLink}>
            Szkolenia
          </Link>
        </li>
        {/* <li>
          <Link to="/shop" onClick={closeMenu} className={`${styles.navLink} ${styles.disabledLink}`}>
            Sklep
          </Link>
        </li> */}
        <li>
          <a href="/#cooperation">Współpraca</a>
        </li>
        <li>
          <a href="/#faq">FAQ</a>
        </li>
        <li>
          <a href="/#contact">Kontakt</a>
        </li>
      </ul>
      <div className={`${styles.socialIcons}`}>
        <a
          href="https://www.facebook.com/artkozit"
          aria-label="Facebook"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Facebook className={styles.icon} />
        </a>
        <a href="/#">
          <Instagram className={styles.icon} />
        </a>
      </div>
      <div
        className={`${styles.menuToggle} ${isMenuOpen ? styles.open : ""}`}
        onClick={handleToggle}
      >
        <span />
        <span />
        <span />
      </div>
    </nav>
  );
}
